const BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your base URL
  const token = window.sessionStorage.getItem("jwtToken");

export const StrategyService = async (strategyCode) => {
  try {
    const response = await fetch(`${BASE_URL}/backtest/strategy-details/${strategyCode}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': 'http://68.183.95.58:8080',
        'Access-Control-Allow-Credentials': 'true',
        'Authorization': token ? `Bearer ${token}` : "",
      },
 
    });
    if (!response.ok) {
      throw new Error('Failed to get strategy data');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error getting strategy data:', error);
    throw error;
  }
};


export const LiveStrategiesService = async () => {
  try {
    const response = await fetch(`${BASE_URL}/liveStrategies`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': 'http://68.183.95.58:8080',
        'Access-Control-Allow-Credentials': 'true',
         Authorization: `Bearer ${token}`
      },
 
    });
    if (!response.ok) {
      throw new Error('Failed to get strategy data');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error getting strategy data:', error);
    throw error;
  }
};


export const AddStrategyDescription = async (strategyDescription) => {
  try {
    const response = await fetch(`${BASE_URL}/addStrategyDescription`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(strategyDescription),
    });

    console.log('Response:', response); // Debugging

    if (!response.ok) {
      console.error('Server responded with error:', response.status);
      throw new Error('Failed to add strategy description');
    }

    const data = await response.json();
    console.log('Response Data:', data); // Debugging

    return data;
  } catch (error) {
    console.error('Error adding strategy description:', error);
    throw error;
  }
};

// services/strategyService.js


export const linkStrategyToDescription = async (strategyCode, strategyDescriptionCode) => {
  const payload = {
    strategyCode: strategyCode,
    strategyDescriptionCode: strategyDescriptionCode,
  };

  try {
    // Correct the fetch URL by closing the string properly
    const response = await fetch(`${BASE_URL}/linkStrategyToStrategyDescription`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error('Failed to link strategy');
    }

    return await response.json(); // Return response JSON if needed
  } catch (error) {
    console.error('Error linking strategy to description:', error);
    throw error;
  }
};

